import React from 'react';
import Regions from 'components/Regions/Regions';
import CompaniesCarousel from 'components/Carousel/CompaniesCarousel';
import TextboxContainer from 'components/TextBox/TextboxContainer';
import NewsContainer from 'components/NewsContainer/NewsContainer';
import LinksContainer from 'components/Links/LinksContainer';
import NorwayForYouLogo from '../../images/norveskaZaVas.jpg';
import SokLogo from '../../images/Logo_SOK.png';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="home-page">
      <div className="basic-container">
        <div className="box-container ">
          <Regions></Regions>
          <div className="child-50 d-flex flex-column align-items-center">
            <TextboxContainer></TextboxContainer>
            <NewsContainer></NewsContainer>
          </div>
          <div className="child-20 d-flex flex-column">
            <LinksContainer></LinksContainer>
            <div duration={2} className="project-sidebar">
              <Link to={'/sok-project/'}>
                <img
                  src={SokLogo}
                  style={{ height: '80px' }}
                  className="company-image"
                  alt="sok"
                ></img>
                <h3>PROJEKAT</h3>
              </Link>
            </div>
            <div
              duration={2}
              style={{ width: '100%', height: '100px', marginTop: '20px' }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.norveskazavas.org.rs/"
              >
                <img
                  className="company-image"
                  style={{ objectFit: 'cover' }}
                  src={NorwayForYouLogo}
                  alt="norway"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <CompaniesCarousel></CompaniesCarousel>
    </div>
  );
}

export default HomePage;
